import { render } from "./ReportTab.vue?vue&type=template&id=40e27f2a&scoped=true"
import script from "./ReportTab.vue?vue&type=script&lang=js"
export * from "./ReportTab.vue?vue&type=script&lang=js"

import "./ReportTab.vue?vue&type=style&index=0&id=40e27f2a&scoped=true&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e27f2a"]])

export default __exports__